import { Testimonial } from "./Testimonials";

export const sampleTestimonials: Testimonial[] = [
  {
    id: "27",
    quote:
      "I just want to thank you for the great book! I enjoyed every page so far!",
    author: "Hatem Hatamleh",
    title: "Software Engineer in Test | Agentic AI | Founder of QAcart",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/hatem-hatamleh/",
    highlights: ["great book", "enjoyed every page"],
  },
  {
    id: "26",
    quote:
      "Instead of focusing on how to use a specific framework, it walks you through building a minimal but feature-complete multi-agent system from the ground up. These are not surface-level topics. They're the design decisions that determine whether a system remains maintainable as complexity grows.",
    author: "Shanoj Kumar V",
    title: "VP - Senior Technology Architecture Manager",
    company: "Citi",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink:
      "https://www.linkedin.com/feed/update/urn:li:activity:7431174643966771200/",
    highlights: [
      "minimal but feature-complete multi-agent system from the ground up",
      "design decisions",
      "maintainable as complexity grows",
    ],
  },
  {
    id: "25",
    quote:
      "This book does an excellent job bridging theory and practice. It covers everything from deterministic agent workflows and autonomous orchestration to real-world production considerations such as evaluation, safety, security, and ethics. What I appreciated most is that it doesn't treat agents as demos or experiments but rather treats them as systems you actually have to operate, test, and trust in production.",
    author: "Christian Coello",
    title: "Global Partner Cloud Solution Architect",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/christiancoello/",
    highlights: [
      "bridging theory and practice",
      "real-world production considerations",
      "systems you actually have to operate, test, and trust in production",
    ],
  },
  {
    id: "24",
    quote:
      "Really appreciate the work that went into making these ideas practical and accessible.",
    author: "Rodolfo Lerma",
    title: "Senior Data Scientist",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink:
      "https://www.linkedin.com/feed/update/urn:li:activity:7407917917066997760/",
    highlights: ["practical and accessible"],
  },
  {
    id: "23",
    quote:
      "The flow was excellent. The content was rich. The examples were engaging. I had such a great time on my journey through this book. I encourage everyone interested in AI agents to pick up a copy.",
    author: "Ingrid Allen",
    title: "Senior Product Manager",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink:
      "https://www.linkedin.com/feed/update/urn:li:activity:7409727550555590656/",
    highlights: [
      "flow was excellent",
      "content was rich",
      "examples were engaging",
      "great time on my journey",
    ],
  },
  {
    id: "22",
    quote:
      "Really good to understand what happens under the hood, in order to make informed decisions on what frameworks, patterns and designs to use.",
    author: "David Hernandez Diez",
    title: "AI Consultant",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink:
      "https://www.linkedin.com/feed/update/urn:li:activity:7412844891086639104/",
    highlights: [
      "understand what happens under the hood",
      "make informed decisions",
      "frameworks, patterns and designs",
    ],
  },
  {
    id: "21",
    quote:
      "When I head off on vacation next week, I plan to fork the samples repo and explore them to build my own intuition of the space. I hope you do too.",
    author: "Nitya Narasimhan, PhD",
    title: "Senior Cloud Advocate, AI",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/intya/",
    highlights: ["fork the samples repo", "build my own intuition"],
  },
  {
    id: "20",
    quote:
      "As someone who has been in industry for 30 years, I recognize the traits of a good educator - someone who brings their own research & engineering experience to deliver content that covers concepts but also drives applied learning with use cases, code samples and most importantly - a constant finger on the pulse of where that industry is headed.",
    author: "Nitya Narasimhan, PhD",
    title: "Senior Cloud Advocate, AI",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/intya/",
    highlights: [
      "good educator",
      "applied learning",
      "use cases, code samples",
      "finger on the pulse",
    ],
  },
  {
    id: "19",
    quote:
      "Been reading this, and it is helping to really make sense of multi agent system design. Incredible work!",
    author: "David Butler",
    title: "Reader",
    rating: 5,
    featured: true,
    type: "reader",
    highlights: [
      "helping to really make sense",
      "multi agent system design",
      "Incredible work",
    ],
  },
  {
    id: "18",
    quote:
      "This is the first book I've read on AI agents that really nails the architecture side of multi-agent systems. It explains clearly when you actually need multiple agents, and just as importantly, when a single agent or plain old code is the better choice. The discussion of workflows as computational graphs, round-robin style coordination, and other orchestration patterns is very practical and grounded in real trade-offs. I especially liked how it explains autonomy vs control: you see exactly how much complexity you're adding each time you give agents more freedom, and how to keep things observable and debuggable. If you care about designing agent systems that are reliable rather than magical, this is an excellent guide.",
    author: "Daniel G Halwell",
    title: "Reader",
    rating: 5,
    featured: true,
    type: "reader",
    highlights: [
      "nails the architecture side",
      "when you actually need multiple agents",
      "when a single agent or plain old code is the better choice",
      "very practical and grounded in real trade-offs",
      "autonomy vs control",
      "observable and debuggable",
      "reliable rather than magical",
    ],
  },
  {
    id: "17",
    quote:
      'In the incredibly noisy landscape of AI agents, Victor\'s voice stands out as a true signal. "Designing Multi-Agent Systems" is an amazing compilation of trends and aspects related to all things agents. With this publication, Victor is providing substantial value to an otherwise hype-driven industry.',
    author: "Hannes Hapke",
    title: "Head of the Open Source Office",
    company: "Dataiku",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/hanneshapke/",
    highlights: [
      "Victor's voice stands out as a true signal",
      "amazing compilation",
      "substantial value",
      "otherwise hype-driven industry",
    ],
  },
  {
    id: "16",
    quote:
      "I've just finished the first four chapters, and this book truly delivers on its promises. It starts strong with the fundamentals and key design patterns for multi-agent collaboration. From there, it moves into a clear, structured, and highly educational deep dive into building a full multi-agent framework, covering all the essential concepts. Victor Dibia, PhD: If I had to complain… it would be about the choice of Python instead of C# 😅. Excited to continue reading and explore what comes next!",
    author: "Ousmane Barry",
    title: "Architecte Solution Azure & AI | MVP Azure AI Foundry",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/ousmanebarry/",
    highlights: [
      "truly delivers on its promises",
      "strong with the fundamentals",
      "key design patterns",
      "clear, structured, and highly educational",
      "deep dive into building a full multi-agent framework",
      "essential concepts",
    ],
  },
  {
    id: "15",
    quote:
      "Just finished reading Victor's 'Designing Multi-Agent Systems' and it is must read. His book serves the perfect tour of how agents collaborate, negotiate, and learn. If you're building agentic platforms or thinking about AI ecosystems please pick it up.",
    author: "Maria Naggaga",
    title: "Sr. Principal Product Manager Core AI",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/maria-naggaga-0299251a/",
    highlights: [
      "must read",
      "perfect tour",
      "building agentic platforms",
      "AI ecosystems",
    ],
  },
  {
    id: "14",
    quote:
      "Victor has an amazing ability to take complex and quickly evolving topics like AI & Agents and distill down to understandable core concepts that are actionable and easy to understand. This coupled with his work building Agent Platforms from MSR's AutoGen to AgentFramework make him one of my go to experts when thinking through the concepts, protocols, platforms and tools we need to build in CoreAI.",
    author: "Caitie McCaffrey",
    title:
      "Partner Software Engineer & Architect - CoreAI; Technical Lead of Model Context Protocol (MCP)",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/caitie-mccaffrey/",
    highlights: [
      "amazing ability",
      "complex and quickly evolving topics",
      "understandable core concepts",
      "actionable and easy to understand",
      "go to experts",
    ],
  },
  {
    id: "11",
    quote:
      "As a researcher at Microsoft who is close to the leading edge of Agentic capabilities, works with Microsoft customers on real world applications, and with the Autogen team on building the agent framework, Victor has a unique vantage point. He uses it to provide an exceptionally clear conceptual explanation of what agents can do, how to elicit complex behavior in real world applications by using multiple agents, and how to leverage multi agent frameworks.",
    author: "Valliappa Lakshmanan",
    title:
      "Co-founder & CTO, Obin AI; Author of Generative AI Design Patterns (O'Reilly); Former Director, Google Cloud",
    company: "Obin AI",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/valliappalakshmanan/",
    highlights: [
      "leading edge of Agentic capabilities",
      "unique vantage point",
      "exceptionally clear conceptual explanation",
      "real world applications",
    ],
  },
  {
    id: "10",
    quote:
      "Practical, easy-to-use guidance and explanations from one of the foremost experts in the industry. Holding this book you have a true pioneer guiding you along the best path.",
    author: "Ryan Sweet",
    title: "Technical Director, Applied Science, Autonomous AI",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/mryansweet/",
    highlights: ["foremost experts in the industry", "true pioneer", "best path"],
  },
  {
    id: "3",
    quote:
      "I have known Victor and his work for many years. With Designing Multi-Agent Systems, I was struck by how comprehensively it captures the state of the art. From foundational principles to hands-on orchestration patterns and rigorous evaluation methods, this book bridges theory and practice in a way few resources do. This is essential reading for engineers who want to truly understand how to design robust multi-agent systems.",
    author: "Dr. David Adamo Jr.",
    title: "Senior Software Engineer",
    company: "Square Inc.",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/davidadamojr",
    highlights: [
      "comprehensively it captures the state of the art",
      "bridges theory and practice",
      "essential reading",
    ],
  },
  {
    id: "7",
    quote:
      "Designing Multi-Agent Systems is the definitive practical guide for building production-ready AI agents, offering both comprehensive foundational principles and hands-on patterns that bridge theory and implementation. Victor Dibia's thoughtful coverage of evaluation, optimization, and responsible AI deployment makes this an indispensable resource for anyone or any organization serious about building AI agents.",
    author: "Adewale Akinfaderin",
    title: "Sr Data Scientist - Generative AI",
    company: "Amazon Web Services",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/adewaleakinfaderin/",
    highlights: [
      "definitive practical guide",
      "production-ready",
      "comprehensive foundational principles",
      "hands-on patterns",
      "bridge theory and implementation",
      "thoughtful coverage",
      "indispensable resource",
    ],
  },
  {
    id: "5",
    quote:
      'Having worked with Victor during our time together at Cloudera, I witnessed firsthand his meticulous attention to detail, thoroughness, and exceptional ability to communicate complex technical concepts. These qualities really shine through in "Designing Multi-Agent Systems." This book addresses a critical gap in the field—while many resources focus on tools and frameworks, few provide the principled foundation needed to make sound architectural decisions. His emphasis on building from scratch ensures readers truly understand the underlying mechanics and can make informed decisions about when and why to leverage existing frameworks. What sets this work apart is Victor\'s ability to bring structured thought leadership to one of the fastest-evolving domains in AI. The balance of theory and practice, combined with his framework-agnostic approach to teaching, makes this an invaluable resource for practitioners who need to navigate the complexity of multi-agent systems thoughtfully. I highly recommend it for anyone aiming to understand how, why, and when multi-agent systems work!',
    author: "Andrew Reed",
    title: "Senior AI Engineer",
    company: "LangChain",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://x.com/andrewrreed",
    highlights: [
      "meticulous attention to detail",
      "exceptional ability to communicate complex technical concepts",
      "addresses a critical gap",
      "principled foundation",
      "structured thought leadership",
      "invaluable resource",
    ],
  },
  {
    id: "4",
    quote:
      'Dr. Victor Dibia stands out as one of the most insightful thinkers, practitioners, and communicators in the burgeoning field of Generative AI, excelling in both its technical aspects and how we currently, and ideally, interact with it. This book arrives at a pivotal moment, especially as some of the most impressive advancements in Generative AI models occur when they are empowered to utilize tools, resources and each other. In "Designing Multi-Agent Systems," Dibia draws upon his firsthand experience developing modern agentic frameworks at Microsoft to share his expertise. This book is an essential resource for anyone interested in agents, offering clear explanations of the benefits and limitations of agentic systems. Furthermore, it provides practical engineering guidance and examples for those looking to develop such systems. I am confident that this book will become a crucial reference for my own work in designing, developing, and studying human-AI systems, as well as for my agents as they assist me with tasks :)',
    author: "Dr. Gonzalo Ramos",
    title: "Independent HCI+AI researcher",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/gonzaloramos/",
    highlights: [
      "most insightful thinkers, practitioners, and communicators",
      "pivotal moment",
      "essential resource",
      "crucial reference",
    ],
  },
  {
    id: "6",
    quote:
      '"Designing Multi-Agent Systems" by Victor Dibia is a timely and essential book for anyone exploring the rapidly evolving field of Multi-Agent Systems. The author provides a clear introduction to agentic systems and thoughtfully explains key architectural considerations. While the subject matter is deeply technical, the book presents it in an accessible and engaging way. I highly recommend this book to anyone interested in agent-based systems or planning to build such solutions.',
    author: "Dr. Raimondas Lencevicius",
    title: "Principal Research Scientist",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/raimondas-lencevicius",
    highlights: [
      "timely and essential book",
      "clear introduction",
      "accessible and engaging",
      "highly recommend",
    ],
  },
  {
    id: "2",
    quote:
      "Dr. Victor Dibia is a standout leader in the AI agent space—his clarity of thought, hands-on experience building a widely used agent framework, and ability to distill complex concepts make him a trusted voice for anyone building multi-agent systems. If you want practical insight rooted in real-world engineering and research, Victor is the expert to learn from.",
    author: "Dr. Emerson Murphy-Hill",
    title: "Principal Researcher",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "expert",
    highlights: [
      "standout leader",
      "widely used agent framework",
      "trusted voice",
      "the expert to learn from",
    ],
  },
  {
    id: "1",
    quote:
      "The book is a splendid, detailed and well thought out book that dissects the design of multi-agent systems beautifully. The author does a spectacular job of starting at the basics and building concepts and frameworks from the ground up. The book is also very easy to understand - a testament to the author's  technical skill and writing style! Great book!",
    author: "Edidiong-Abasi Ita Anwanane",
    title: "Systems Administrator | Enterprise IT Manager",
    company: "WAIFEM",
    rating: 5,
    featured: true,
    type: "expert",
    profileLink: "https://www.linkedin.com/in/edidiong-abasi-anwanane/",
    highlights: [
      "splendid, detailed and well thought out",
      "spectacular job",
      "magnificent technical skill",
      "writing style",
      "Great book",
    ],
  },
  {
    id: "8",
    quote:
      "I bought the digital book last week and haven't finished all the chapters yet but I can already tell the level of depth you get here is unmatched with anything else out there. Really amazing job!",
    author: "Joarder Kamal, PhD",
    title: "Senior Technology Architect, Digital Natives Asia",
    company: "Microsoft",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/joarderkamal/",
    highlights: [
      "level of depth",
      "unmatched with anything else out there",
      "Really amazing job",
    ],
  },
  {
    id: "9",
    quote:
      "Thank you for pouring so much into this. I got the digital edition today. This is perfect timing.",
    author: "Noah Ratzan",
    title: "Product leadership for conversational AI, ex-Microsoft",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/noahratzan/",
    highlights: ["thank you for pouring so much into this", "perfect timing"],
  },
  {
    id: "12",
    quote: "Congrats on a truly excellent book. I particularly enjoyed Part II.",
    author: "Valliappa Lakshmanan",
    title:
      "Co-founder & CTO, Obin AI; Author of Generative AI Design Patterns (O'Reilly); Former Director, Google Cloud",
    company: "Obin AI",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/valliappalakshmanan/",
    highlights: ["truly excellent book", "particularly enjoyed Part II"],
  },
  {
    id: "13",
    quote:
      "As an early reader of this amazing work, I can say this is the perfect book to learn the fundamentals of what a multi agent system MUST embody. Congrats on getting this out to the world.",
    author: "Jack D.",
    title: "Product Manager | AI Practitioner | Product Experience Engineer",
    rating: 5,
    featured: true,
    type: "reader",
    profileLink: "https://www.linkedin.com/in/techprojackd/",
    highlights: ["amazing work", "perfect book", "fundamentals", "MUST embody"],
  },
];

// Filter helpers
export const featuredTestimonials = sampleTestimonials.filter(
  (t) => t.featured
);
export const industryTestimonials = sampleTestimonials.filter((t) =>
  [
    "WAIFEM",
    "Microsoft",
    "Square Inc.",
    "LangChain",
    "Amazon Web Services",
    "Obin AI",
    "Dataiku",
    "Citi",
  ].includes(t.company || "")
);
export const expertTestimonials = sampleTestimonials.filter(
  (t) => t.type === "expert"
);
export const readerTestimonials = sampleTestimonials.filter(
  (t) => t.type === "reader"
);
export const academicTestimonials = sampleTestimonials.filter(
  (t) => t.type === "academic"
);
